import { DatePicker } from "antd";
import locale from "antd/locale/fr_FR";
import classnames from "classnames";
import Label from "../../Label";

const { RangePicker } = DatePicker;

const Range = ({
  label,
  errors,
  touched,
  icon,
  required,
  direction,
  ...rest
}) => {
  return (
    <div
      className={classnames(
        "miltis__datepicker",
        { "miltis__datepicker--error": touched && errors },
        { "miltis__datepicker--valid": touched && !errors },
        direction,
      )}
    >
      <Label label={label} icon={icon} required={required} />
      <div className="miltis__datepicker--field">
        <RangePicker
          locale={locale}
          className={classnames({ "disabled--input": rest.disabled })}
          {...rest}
        />
        {touched && errors && <p className="input--errors">{errors}</p>}
      </div>
    </div>
  );
};

export default Range;
